import { AiProcessExecutionStatus, AiProcessStepErrorReason } from 'constants/aiProcessRuns';
import { COLOR_PALETTE } from 'constants/ui';

export const PAGE_TITLE = 'AI Activity';

export const LIVE_CARD_TITLE = 'In progress';

export const RUN_HISTORY_TITLE = 'Run history';

export const ALL_STATUSES_VALUE = '__ALL__';

export const STATUS_FILTER_OPTIONS = [
  { value: ALL_STATUSES_VALUE, label: 'All' },
  { value: AiProcessExecutionStatus.RUNNING, label: 'Working' },
  { value: AiProcessExecutionStatus.AWAITING_CONFIRMATION, label: 'Waiting' },
  { value: AiProcessExecutionStatus.COMPLETED, label: 'Done' },
  { value: AiProcessExecutionStatus.FAILED, label: 'Problems' },
  { value: AiProcessExecutionStatus.CANCELLED, label: 'Cancelled' },
];

export const SavedFilterChipId = {
  TODAY: 'today',
  PROBLEMS_ONLY: 'problems-only',
  STARTED_BY_ME: 'started-by-me',
  MANUAL_ONLY: 'manual-only',
  NEEDS_REVIEW: 'needs-review',
};

export const SAVED_FILTER_CHIPS = [
  { id: SavedFilterChipId.TODAY, label: 'Today' },
  { id: SavedFilterChipId.PROBLEMS_ONLY, label: 'Problems only' },
  { id: SavedFilterChipId.STARTED_BY_ME, label: 'Started by me' },
  { id: SavedFilterChipId.MANUAL_ONLY, label: 'Manual only' },
];

export const GroupByMode = {
  DATE: 'date',
  PROCESS: 'process',
};

export const DateGroupKey = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'thisWeek',
  EARLIER: 'earlier',
};

export const DateGroupLabel = {
  [DateGroupKey.TODAY]: 'Today',
  [DateGroupKey.YESTERDAY]: 'Yesterday',
  [DateGroupKey.THIS_WEEK]: 'Earlier this week',
  [DateGroupKey.EARLIER]: 'Older',
};

export const ProcessChipPalette = [
  { backgroundColor: COLOR_PALETTE.BLUE[2], color: COLOR_PALETTE.BLUE[8] },
  { backgroundColor: COLOR_PALETTE.GREEN[2], color: COLOR_PALETTE.GREEN[8] },
  { backgroundColor: COLOR_PALETTE.RED[2], color: COLOR_PALETTE.RED[8] },
  { backgroundColor: COLOR_PALETTE.PURPLE[2], color: COLOR_PALETTE.PURPLE[8] },
  { backgroundColor: COLOR_PALETTE.ORANGE[2], color: COLOR_PALETTE.ORANGE[8] },
  { backgroundColor: COLOR_PALETTE.CYAN[2], color: COLOR_PALETTE.CYAN[8] },
  { backgroundColor: COLOR_PALETTE.MAGENTA[2], color: COLOR_PALETTE.MAGENTA[8] },
  { backgroundColor: COLOR_PALETTE.BLUE_GRAY[2], color: COLOR_PALETTE.BLUE_GRAY[8] },
];

export const ManualTriggerSource = 'Manual';

// Pricing starts a rate-sheet reading on upload ("pricing-upload:grade-3"), or when a person asks
// for one in the upload drawer ("pricing-upload:person:grade-3"). Pricing starts both as its
// system user, so the run's user names the system, not the person.
export const RATE_SHEET_UPLOAD_TRIGGER_PREFIX = 'pricing-upload:';

export const RATE_SHEET_PERSON_TRIGGER_PREFIX = 'pricing-upload:person:';

export const STEP_REASON_LABEL = {
  [AiProcessStepErrorReason.CANCELLED.toLowerCase()]: 'Cancelled',
  [AiProcessStepErrorReason.STOPPED_AFTER_FAILURE.toLowerCase()]: 'Stopped after failure',
  [AiProcessStepErrorReason.DEPENDENCY_OUTPUT_MISSING.toLowerCase()]: 'Input removed',
  [AiProcessStepErrorReason.STEP_LOST.toLowerCase()]: 'Lost',
};

export const FAILURE_ONLY_REASON_LABEL_KEYS = new Set([
  AiProcessStepErrorReason.DEPENDENCY_OUTPUT_MISSING.toLowerCase(),
  AiProcessStepErrorReason.STEP_LOST.toLowerCase(),
]);

export const NEEDS_ATTENTION_WINDOW_DAYS = 7;

export const AVG_DURATION_WINDOW_DAYS = 30;

export const ROW_EXPANSION_SUMMARY_EVENT_COUNT = 5;

// Above AdminSlideDrawer's 1300 so the guideline full-section drawer opens on top
// of the run detail drawer (its chat-tuned default z-index sits below it).
export const EXECUTION_GUIDELINE_FULL_VIEW_Z_INDEX = 1_350;
